import { IFile } from 'coreOld/types';
import {
  SERVER_FORMAT_DATE,
  formatDate,
  mapArray,
  objectKeysCamelToSnakeCase,
} from 'coreOld/utils';
import { IJob } from 'jobsOld/types';
import { IRequest, IRequestForm, IRequestJobs, IUpdateRequestForm } from 'support/types';

export const mapUpsertRequestJobs = (
  supportRequestId: number,
  projectId: number,
  customerCompanyName: string,
  jobs: IJob[]
) =>
  objectKeysCamelToSnakeCase({
    boms: jobs.map((job: IJob) => ({
      id: job?.id,
      jobName: job.name,
      details: job.details,
      supportRequestId,
      projectId,
      disciplineId: job.disciplineId,
      otherDiscipline: !job?.disciplineId ? job.disciplineName : null,
      files: job?.attachments ?? [],
      customerCompanyName: !job?.id ? customerCompanyName : null,
    })),
  });

export const mapUpsertRequestForm = (data: IRequestForm) => {
  const { customerNumberNotRequired, requiredByDate, type, ...rest } = data;

  const typeId = -1 === type ? null : type;

  return objectKeysCamelToSnakeCase({
    supportRequest: {
      ...rest,
      requiredByDate: formatDate(requiredByDate, false, SERVER_FORMAT_DATE),
      customerNumberRequired: customerNumberNotRequired ? 0 : 1,
      typeId: typeId,
    },
  });
};

export const mapRequestToRequestJobs = (request: IRequest, attachments?: IFile[]): IRequestJobs => {
  if (!request) {
    return { jobs: [] };
  }

  const { bomsMap } = request;
  const attachmentsMap = mapArray(attachments ?? [], 'bomId');

  const jobs = [];

  for (const jobId in bomsMap) {
    const job = bomsMap[jobId];

    jobs.push({
      ...job,
      id: jobId,
      attachments: attachmentsMap?.[jobId],
    });
  }

  return { jobs };
};

export const mapRequestToForm = (request: IRequest): IRequestForm => {
  if (!request) {
    return {
      projectName: '',
      customerCompanyName: '',
      requiredByDate: null,
      customerNumber: '',
      customerNumberNotRequired: false,
      customerFirstName: '',
      customerLastName: '',
      customerEmail: '',
      type: -1,
    };
  }

  const { requiredByDate, customerNumberRequired, typeId, ...rest } = request;

  return {
    ...rest,
    requiredByDate: new Date(requiredByDate),
    customerNumberNotRequired: !customerNumberRequired,
    type: typeId || -1,
  };
};

export const mapUpsertRequestsForm = (requests: IRequest[], data: IUpdateRequestForm) => {
  let formattedData = {};
  if (data?.requiredByDate) {
    formattedData = {
      requiredByDate: formatDate(data.requiredByDate, false, SERVER_FORMAT_DATE),
    };
  }

  return objectKeysCamelToSnakeCase({
    supportRequests: requests.map((request) => ({
      id: request.id,
      ...data,
      ...formattedData,
    })),
  });
};
